import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Rightbar from "../CommonForBoth/Rightbar";
import { BACKEND_URL } from "../../services/backendURL";
import axios from 'axios';
import { handleError } from '../../helpers/handleError'

class Layout extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      task_nr: "",
      notif_tasks: [],
      notifications: [],
    }

    this.toggleMenuCallback = this.toggleMenuCallback.bind(this)
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this)
    this.singleTask = this.singleTask.bind(this)
    this.downloadData = this.downloadData.bind(this)
    this.seeNotification = this.seeNotification.bind(this)
  }

  toggleRightSidebar() {
    this.props.toggleRightSidebar()
  }

  capitalizeFirstLetter = string => {
    return string.charAt(1).toUpperCase() + string.slice(2)
  }

  componentDidMount() {
    if (this.props.isPreloader === true) {
      document.getElementById('preloader').style.display = "block";
      document.getElementById('status').style.display = "block";

      setTimeout(function () {

        document.getElementById('preloader').style.display = "none";
        document.getElementById('status').style.display = "none";

      }, 2500);
    }
    else {
      document.getElementById('preloader').style.display = "none";
      document.getElementById('status').style.display = "none";
    }

    window.scrollTo(0, 0)

    // let currentage = this.capitalizeFirstLetter(this.props.location.pathname);

    document.title = "Anëtari";
 
    let color = localStorage.getItem("color")

    if (color) {
      this.props.changeSidebarTheme(color);
    } else {
      this.props.changeSidebarTheme("dark");
    }

    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth);
    }

    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType);
    }

    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme);
    }

    if (this.props.showRightSidebar) {
      this.toggleRightSidebar();
    }
    
    // only do this for the first time
    let loa = localStorage.getItem('loaded')
    let loaded = JSON.parse(loa)
    if (!loaded) {
      this.downloadData()
    }
  }
  
  downloadData() {
    let tok = localStorage.getItem('authUser')
    let token = JSON.parse(tok)
    const config = {
      headers: {
        'Authorization': "Token " + token.key
      },
    };
    
    let url1 = BACKEND_URL + "/api/hr/usernotifications/" ;
    let url2 = BACKEND_URL + "/api/sns/my-new-notifications/" ;
    
    const request1 = axios.get(url1, config);
    const request2 = axios.get(url2, config);
    
    axios.all([request1,request2])
    .then(axios.spread((...responses)=>{
      localStorage.setItem("loaded", JSON.stringify(true));

      const response1 = responses[0].data
      const response2 = responses[1].data

      this.setState({...this.state,
        task_nr: response1.task_nr,
        notif_tasks: response1.member_tasks,
        notifications: response2,
      })
    }))
    .catch(error=>{
      handleError(error, this.props.history)
    })
  }

  // handleSeeNotification
    // POST /api/sns/see-notification/

  toggleMenuCallback = () => {
    if (this.props.leftSideBarType === "default") {
      this.props.changeSidebarType("condensed", this.state.isMobile)
    } else if (this.props.leftSideBarType === "condensed") {
      this.props.changeSidebarType("default", this.state.isMobile)
    }
  }

  singleTask(index) {
    let header =  {header: this.state.notif_tasks[index]}
    localStorage.setItem("headerPush", JSON.stringify(header));
    this.props.history.push('/task-view')
  }

  seeNotification(notification) {
    this.props.history.push('/notification-view', notification)
  }

  render() {
    return (
      <React.Fragment>
        <div id="preloader">
          <div id="status">
            <div className="spinner-chase">
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
            </div>
          </div>
        </div>

        <div id="layout-wrapper">
          <Header 
            task_nr={this.state.task_nr}
            notif_tasks={this.state.notif_tasks}
            allTasks={()=>{this.props.history.push('/tasks-received')}}
            singleTask={this.singleTask}
            toggleMenuCallback={this.toggleMenuCallback} 
            toggleRightSidebar={this.toggleRightSidebar} 
            seeNotification={this.seeNotification}
            notifications={this.state.notifications}
          />
          
          <Sidebar theme={this.props.leftSideBarTheme}
            type={this.props.leftSideBarType}
            isMobile={this.state.isMobile} 
          />

          <div className="main-content">
            {this.props.children}
          </div>
        </div>
        <Rightbar />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  return {
    ...state.Layout
  };
};

export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth,
})(withRouter(Layout));